/* eslint-disable no-multi-assign */
/* eslint-disable no-return-assign */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable consistent-return */
/* eslint-disable require-await */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { isGumCase } from '@brands/Utils/isGumCase';
import GumLogo from '../../../../gum-virtual-care/Dashboard/Appointments/assets/oHRLogo.svg';
import LogoPNG from '@brands/assets/logo.png';
import BrandLogo from '@brands/Components/BrandLogo/BrandLogo';
import Button from '@brands/Components/Button/Button';
import Container from '@brands/Components/Container/Container';
import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import SlideshowProps from '@brands/Components/Slideshow/Slideshow';
import Logo from '@brands/Dashboard/Appointments/assets/logo.svg';
import LogoMobile from '@brands/Dashboard/Appointments/assets/logoMobile.svg';
import { VideoCaseNotAvailableModal } from '../../../../default/Dashboard/PatientForms/PatientForm/SelectPatient/SelectPatient';
import { useOrganizationFlags, useWindowSize } from '@brands/hooks';
import { useLoadCustomerIoInApp } from '@brands/hooks/useLoadCustomerIoInApp';
import { useAppDispatch, useAppSelector } from '@brands/hooks/useReduxHook';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { getOneCase } from '@brands/services/cases/getCaseById';
import { ICase } from '@brands/services/cases/types/ICase';
import { SmileScanReport, SmileScanReportMedia } from '@brands/services/cases/types/SmileScanReport';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { getOneReportMedia } from '@brands/services/oneReport/getOneReportMedia';
import { getSmileScanReports } from '@brands/services/oneReport/getSmileScanReports';
import { IMedia } from '@brands/services/oneReport/types/IMedia';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectClientBranding } from '@brands/store/selectors/clientBranding';
import { selectCurrentPatientState } from '@brands/store/selectors/currentPatientState';
import { setForm, setIsFromSmileScanReport, UploadedFile } from '@brands/store/slices/patientFormSlice';
import { displayErrorDetails } from '@brands/Utils/displayError';
import { convertZoneAbbr, getTimezoneAbbreviation } from '@brands/Utils/getParsedTimezoneName';
import { DEFAULT_PATIENT_LOCATION_STATE } from '@brands/Utils/localStorage';
import * as html2pdf from 'html2pdf.js';
import moment from 'moment';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { useParams } from 'react-router-dom';

import RiskTextDisplay, { Category, RiskLevel } from './RiskTextDisplay';
import styles from './smileScanReport.module.scss';
import arrow from './utils/icons/arrow.svg';
import download from './utils/icons/download.svg';
import { DiseaseAssessment, smileScanMapper, SmileScanReportWithDiseaseAssessment } from './utils/smileScanMapper';

const A4_HEIGHT_PT = 841.89;
const PT_TO_PX = 96 / 72;

const getMimeType = (filename: string): string => {
  const ext = filename.split('.').pop()?.toLowerCase();
  switch (ext) {
    case 'jpeg':
    case 'jpg':
      return 'image/jpeg';
    case 'png':
      return 'image/png';
    case 'gif':
      return 'image/gif';
    case 'webp':
      return 'image/webp';
    default:
      return '';
  }
};

const getRecord = (value: unknown): Record<string, unknown> | null => {
  if (value && typeof value === 'object' && !Array.isArray(value)) return value as Record<string, unknown>;
  if (typeof value === 'string' && value.trim().startsWith('{')) {
    try {
      return getRecord(JSON.parse(value));
    } catch {
      return null;
    }
  }
  return null;
};

const getStringField = (source: unknown, keys: string[]): string | undefined => {
  const record = getRecord(source);
  if (!record) return undefined;

  for (const key of keys) {
    const value = record[key];
    if (typeof value === 'string' && value.trim()) return value.trim();
    if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  }
  return undefined;
};

const cleanSmileScanMediaIdKeys = [
  'clinical_media_id',
  'clinicalMediaId',
  'clean_media_id',
  'cleanMediaId',
  'clean_image_media_id',
  'cleanImageMediaId',
  'media_id_without_boxes',
  'mediaIdWithoutBoxes',
  'media_id_without_bounding_boxes',
  'mediaIdWithoutBoundingBoxes',
  'non_annotated_media_id',
  'nonAnnotatedMediaId',
  'non_annotated_image_media_id',
  'nonAnnotatedImageMediaId',
  'original_media_id',
  'originalMediaId',
  'original_image_media_id',
  'originalImageMediaId',
  'original_file_media_id',
  'originalFileMediaId',
  'original_upload_id',
  'originalUploadId',
  'raw_media_id',
  'rawMediaId',
  'raw_image_media_id',
  'rawImageMediaId',
  'raw_file_media_id',
  'rawFileMediaId',
  'source_media_id',
  'sourceMediaId',
  'source_image_media_id',
  'sourceImageMediaId',
  'source_upload_id',
  'sourceUploadId',
  'captured_media_id',
  'capturedMediaId',
  'capture_media_id',
  'captureMediaId',
  'input_media_id',
  'inputMediaId',
  'unprocessed_media_id',
  'unprocessedMediaId',
  'unprocessed_image_media_id',
  'unprocessedImageMediaId',
  'unannotated_media_id',
  'unannotatedMediaId',
  'unannotated_image_media_id',
  'unannotatedImageMediaId',
  'smilescan_original_media_id',
  'smilescanOriginalMediaId',
  'smile_scan_original_media_id',
  'smileScanOriginalMediaId',
  'toothlens_original_media_id',
  'toothlensOriginalMediaId',
];

const cleanSmileScanMediaContainerKeys = [
  'attributes',
  'metadata',
  'meta',
  'toothlens',
  'tooth_lens',
  'smilescan',
  'smile_scan',
  'clinical_image',
  'original_image',
];

const getCleanSmileScanMediaId = (source: unknown): string | undefined => {
  const record = getRecord(source);
  if (!record) return undefined;

  const directMediaId = getStringField(record, cleanSmileScanMediaIdKeys);
  if (directMediaId) return directMediaId;

  for (const key of cleanSmileScanMediaContainerKeys) {
    const nestedMediaId = getCleanSmileScanMediaId(record[key]);
    if (nestedMediaId) return nestedMediaId;
  }

  return undefined;
};

const getSmileScanClinicalMediaId = (media: SmileScanReportMedia): string | undefined => {
  const reportMediaRecord = getRecord(media);
  const reportMediaAttributes = getRecord((media as SmileScanReportMedia & { attributes?: unknown }).attributes);
  const mediaRecord = getRecord(media.media);
  const attributes = getRecord(media.media?.attributes);

  return (
    getCleanSmileScanMediaId(reportMediaAttributes) ||
    getCleanSmileScanMediaId(reportMediaRecord) ||
    getCleanSmileScanMediaId(attributes) ||
    getCleanSmileScanMediaId(mediaRecord) ||
    media.media_id
  );
};

const getSmileScanCaseImages = (
  smileScanReport: SmileScanReportWithDiseaseAssessment | undefined,
  displayedMedia: IMedia[],
): UploadedFile[] => {
  // Do not fetch displayed media.url here; that URL is the report image with SmileScan boxes baked in.
  const media = smileScanReport?.media || [];

  return media
    .map((item, index) => {
      const matchingDisplayedMedia = displayedMedia.find(
        (displayed) => displayed.id === item.media_id || displayed.id === item.media?.id,
      );
      const mediaId = getSmileScanClinicalMediaId(item);
      if (!mediaId) return null;

      const name = item.media?.filename || matchingDisplayedMedia?.filename || `SmileScanImage-${index + 1}.jpg`;
      const mimetype =
        item.media?.mimetype || matchingDisplayedMedia?.mimetype || getMimeType(name) || 'application/octet-stream';

      return { name, media_id: mediaId, mimetype };
    })
    .filter(Boolean) as UploadedFile[];
};

const SmileScanReportComponent = (): JSX.Element => {
  const screenSize = useWindowSize();
  const { userInfo } = useAppSelector(selectAuth);
  const clientBranding = useAppSelector(selectClientBranding);
  const currentState = useAppSelector(selectCurrentPatientState);
  const roleNavigate = useRoleNavigate();
  const dispatch = useAppDispatch();
  const isMobile = screenSize.width < 768;
  const routeCaseId = useParams().caseId as string;
  const { videoCaseEnabled } = useOrganizationFlags(currentState[userInfo.id] || DEFAULT_PATIENT_LOCATION_STATE);

  const [isDownloadMode, setIsDownloadMode] = useState(false);
  const [smileScanReportsWithDiseaseAssessment, setSmileScanReportsWithDiseaseAssessment] = useState<
    SmileScanReportWithDiseaseAssessment[]
  >([]);
  const [selectedSmileScanReport, setSelectedSmileScanReport] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [images, setImages] = useState<Array<IMedia>>([]);
  const [thisCase, setThisCase] = useState<ICase | null>(null);
  const [videoCaseTypeEnabled, setVideoCaseTypeEnabled] = useState<boolean>(false);
  const [headerLogoDataUrl, setHeaderLogoDataUrl] = useState<string | null>(null);

  useLoadCustomerIoInApp(userInfo.role.name === UserRoleName.Patient);

  const pngToHiDpiDataUrl = (url: string, drawWidthPt = 110, drawHeightPt = 28, scale = 3): Promise<string> =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(drawWidthPt * scale);
        canvas.height = Math.round(drawHeightPt * scale);
        const ctx = canvas.getContext('2d');
        if (!ctx) return reject(new Error('No 2D context'));
        ctx.scale(scale, scale);
        const r = Math.min(drawWidthPt / img.width, drawHeightPt / img.height);
        const w = img.width * r;
        const h = img.height * r;
        const dx = (drawWidthPt - w) / 2;
        const dy = (drawHeightPt - h) / 2;
        ctx.clearRect(0, 0, drawWidthPt, drawHeightPt);
        ctx.drawImage(img, dx, dy, w, h);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = reject;
      img.src = url;
    });

  useEffect(() => {
    let cancelled = false;
    setHeaderLogoDataUrl(null);
    pngToHiDpiDataUrl(isGumCase(thisCase) ? GumLogo : LogoPNG, 110, 28, 3)
      .then((dataUrl) => {
        if (!cancelled) setHeaderLogoDataUrl(dataUrl);
      })
      .catch(() => {
        if (!cancelled) setHeaderLogoDataUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [thisCase?.client?.code, thisCase?.organization?.id]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      let patientId = '';
      let reports: SmileScanReport[] = [];

      try {
        const response = await getOneCase(Number(routeCaseId));
        setThisCase(response);
        patientId = response.patient_id.toString() || '';
      } catch (error) {
        displayErrorDetails(error);
      }

      try {
        reports = await getSmileScanReports(patientId, userInfo.role.name);
      } catch (error) {
        displayErrorDetails(error);
      }

      if (reports.length > 0) {
        const reportsWithDiseaseAssessment: SmileScanReportWithDiseaseAssessment[] = [];
        const currentReport = reports.find((report) => report.case_id === Number(routeCaseId));
        if (currentReport) setSelectedSmileScanReport(reports.indexOf(currentReport));
        await reports.forEach((smileScanReport) => {
          const mappedReport = smileScanMapper(smileScanReport);
          reportsWithDiseaseAssessment.push(mappedReport);
        });
        setSmileScanReportsWithDiseaseAssessment(reportsWithDiseaseAssessment);
      }
      setLoading(false);
    })();
  }, [routeCaseId]);

  useEffect(() => {
    (async () => {
      if (smileScanReportsWithDiseaseAssessment.length > 0) {
        setLoading(true);
        const selectedReport = smileScanReportsWithDiseaseAssessment[selectedSmileScanReport];
        if (selectedReport?.media) {
          try {
            const imgs = await Promise.all(
              selectedReport.media.map(async (media: SmileScanReportMedia) => {
                try {
                  const response = await getOneReportMedia(media.media_id || '');
                  return response;
                } catch (error) {
                  displayErrorDetails(error);
                  return null;
                }
              }),
            );
            const validImgs = imgs.filter((img): img is IMedia => img !== null);
            setImages(validImgs.length > 0 ? validImgs : []);
          } catch (error) {
            displayErrorDetails(error);
          }
        }
        setLoading(false);
      }
    })();
  }, [smileScanReportsWithDiseaseAssessment, selectedSmileScanReport]);

  const getGradeFromValue = useMemo((): ((d: DiseaseAssessment) => { grade: string; color: string; id: RiskLevel }) => {
    return (disease: DiseaseAssessment) => {
      const value = disease.value as number;
      const category = disease.id as Category;
      if (value >= (category === 'cavity_score' ? 55 : 70)) return { grade: 'High Risk', color: '#FF0000', id: 'high' };
      if (value >= (category === 'cavity_score' ? 50 : 40))
        return { grade: 'Moderate Risk', color: '#FF8A00', id: 'moderate' };
      return { grade: 'Low Risk', color: '#13A700', id: 'low' };
    };
  }, []);

  const getGradeFromOverallScore = (score: number): { grade: string; color: string } => {
    if (score > 70) return { grade: 'Low Risk', color: '#13A700' };
    if (score > 35) return { grade: 'Moderate Risk', color: '#FF8A00' };
    return { grade: 'High Risk', color: '#FF0000' };
  };

  const calculateScoreChange = (
    currentScore: number,
    previousScore: number,
  ): { change: number; percentageChange: string; changeDirection: string } => {
    const change = currentScore - previousScore;
    const absChange = Math.abs(change);
    const percentageChange = ((change / Math.max(previousScore, 1)) * 100).toFixed(1);
    const changeDirection = change === 0 ? '' : change > 0 ? 'up' : 'down';
    return { change: absChange, percentageChange, changeDirection };
  };

  // Prefer to capture the dedicated download container; fall back to any element with that id.
  const componentRef = useRef<HTMLDivElement>(null);
  const isSpeakingToDentist = useRef(false);

  // ---------- header drawing ----------
  const drawPerPageHeader = (pdf: any, margin: [number, number, number, number]): void => {
    const total = pdf.internal.getNumberOfPages();
    const pageW = pdf.internal.pageSize.getWidth();
    const [top, right, , left] = margin;

    const sidePad = 10;
    const leftX = left + sidePad;
    const rightX = pageW - right - sidePad;

    const report = smileScanReportsWithDiseaseAssessment[selectedSmileScanReport];
    const patientName =
      `${thisCase?.patient.basic_info.first_name || ''} ${thisCase?.patient.basic_info.last_name || ''}`.trim() ||
      'Dentistry.One';

    const headerDate = formatTime(
      (report?.created_at as string) || '',
      userInfo.role.name === UserRoleName.Patient ? currentState[userInfo.id] : 'NY',
    );

    const nameY = top - 26;
    const dateY = top - 12;
    const lineY = top - 2;
    const logoW = 110;
    const logoH = 28;
    const logoY = nameY - 12;

    for (let i = 1; i <= total; i += 1) {
      pdf.setPage(i);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(12);
      pdf.text(patientName, leftX, nameY);

      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(11);
      pdf.setTextColor(90, 90, 90);
      pdf.text(headerDate, leftX, dateY);

      const logoX = rightX - logoW;
      if (headerLogoDataUrl) pdf.addImage(headerLogoDataUrl, 'PNG', logoX, logoY, logoW, logoH);

      pdf.setDrawColor(208, 208, 208);
      pdf.setLineWidth(0.4);
      pdf.line(leftX, lineY, rightX, lineY);
    }
  };

  // hide the in-DOM download header while we draw our PDF header
  const hideHeadersTemporarily = (root: HTMLElement): (() => void) => {
    const toHide = Array.from(root.querySelectorAll(`.${styles.smileScanReportDownloadHeader}`)) as HTMLElement[];
    const prev: Array<[HTMLElement, string]> = [];
    toHide.forEach((el) => {
      prev.push([el, el.style.display]);
      el.style.display = 'none';
    });
    return () => prev.forEach(([el, val]) => (el.style.display = val));
  };

  // Wait for all <img> to finish loading/decoding so sizes are final before measuring
  const waitForImages = async (root: HTMLElement) => {
    const imgs = Array.from(root.querySelectorAll('img')) as HTMLImageElement[];
    await Promise.all(
      imgs.map((img) => {
        if (img.complete) return Promise.resolve();
        return new Promise<void>((res) => {
          img.onload = img.onerror = () => res();
        });
      }),
    );
  };

  // ========= Smart pagination helper =========
  /**
   * Insert .pdf-break-before markers BEFORE any block that would cross a page boundary,
   * so html2pdf never splits that block. We measure against A4 usable height.
   * Also: allow breaking inside the overview by rows (images/score/colors) when it exceeds one page.
   */
  const applySmartPageBreaks = (container: HTMLElement, topMarginPt: number, bottomMarginPt: number) => {
    // remove previous markers (idempotent for retries)
    container
      .querySelectorAll('.pdf-break-before.__auto, .pdf-break-before-row.__auto, .pdf-page-spacer.__auto')
      .forEach((n) => n.parentElement?.removeChild(n));

    const pageHeightPt = A4_HEIGHT_PT;
    const usableHeightPx = (pageHeightPt - (topMarginPt + bottomMarginPt)) * PT_TO_PX;

    // If overview is taller than a page, allow soft breaks between its direct children
    const overview = container.querySelector(`.${styles.smileScanReportOverview}`) as HTMLElement | null;
    if (overview) {
      const oh = Math.ceil(overview.offsetHeight || 0);
      if (oh > usableHeightPx) {
        overview.classList.add('pdf-avoid-break');
        const kids = Array.from(overview.querySelectorAll(':scope > *')) as HTMLElement[];
        kids.forEach((child, i) => {
          child.style.breakInside = 'avoid';
          child.style.pageBreakInside = 'avoid';
          if (i > 0) {
            const br = document.createElement('div');
            br.className = 'pdf-break-before-row __auto';
            child.parentElement?.insertBefore(br, child);

            const spacer = document.createElement('div');
            spacer.className = 'pdf-page-spacer __auto';
            spacer.style.height = '12px';
            child.parentElement?.insertBefore(spacer, child);
          }
        });
      }
    }

    // We paginate the assessment rows to keep each row intact
    const rows: HTMLElement[] = Array.from(
      container.querySelectorAll(`.${styles.dentalDiseaseAssessmentRow}`),
    ) as HTMLElement[];

    let cursor = 0; // current y position (px) within the page content area
    const pagePaddingPx = 12; // tiny buffer under header line

    rows.forEach((row) => {
      const h = Math.ceil(row.offsetHeight);
      const intro = row.querySelector('.risk-intro') as HTMLElement | null;
      const header = row.querySelector(`.${styles.dentalDiseaseAssessmentRowHeader}`) as HTMLElement | null;
      const keepTogetherMin = (header?.offsetHeight || 0) + (intro?.offsetHeight || 0);

      cursor %= usableHeightPx;
      const remaining = usableHeightPx - cursor;

      // If not enough room for header + first paragraph, break BEFORE this row
      if (remaining < Math.max(keepTogetherMin, 60)) {
        const br = document.createElement('div');
        br.className = 'pdf-break-before __auto';
        row.parentElement?.insertBefore(br, row);
        const spacer = document.createElement('div');
        spacer.className = 'pdf-page-spacer __auto';
        spacer.style.height = '12px';
        row.parentElement?.insertBefore(spacer, row);
        cursor = 0;
      }

      // If the whole row still doesn't fit, break before to keep it intact
      if (h > usableHeightPx - cursor) {
        const br2 = document.createElement('div');
        br2.className = 'pdf-break-before __auto';
        row.parentElement?.insertBefore(br2, row);
        const spacer2 = document.createElement('div');
        spacer2.className = 'pdf-page-spacer __auto';
        spacer2.style.height = '12px';
        row.parentElement?.insertBefore(spacer2, row);
        cursor = 0;
      }

      cursor += h + pagePaddingPx;
    });

    // If a single paragraph is unrealistically tall, allow soft split for that paragraph only
    const bigParas = container.querySelectorAll(`.${styles.dentalDiseaseAssessmentRow} p`);
    bigParas.forEach((p) => {
      const ph = (p as HTMLElement).offsetHeight || 0;
      if (ph > usableHeightPx) {
        (p as HTMLElement).style.pageBreakInside = 'auto';
        (p as HTMLElement).style.breakInside = 'auto';
      }
    });
  };

  // ---------- html2pdf options with smarter pagebreak rules ----------
  // NOTE: we draw a custom header, so top margin is larger (100pt)
  const pdfMargin: [number, number, number, number] = [100, 30, 40, 30];
  const commonPdfOptions = {
    filename: 'SmileScanReport.pdf',
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 3, scrollY: 0, useCORS: true, letterRendering: true },
    jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' as const },
    margin: pdfMargin,
    pagebreak: {
      mode: ['css', 'legacy'] as const,
      before: ['.pdf-break-before', '.pdf-break-before-row'],
      after: ['.pdf-break-after'],
      avoid: [
        '.pdf-avoid-break',
        '.pdf-image-row',
        '.pdf-image-tile',
        `.${styles.dentalDiseaseAssessmentRow}`,
        `.${styles.smileScanReportOverview}`,
        `.${styles.smileScanReportDownloadGridElement}`,
        `.${styles.smileScanReportDisclaimer}`,
        `.${styles.smileScanReportTitle}`,
        '.risk-intro',
        'img',
        'figure',
        'table',
        'p.pdf-keep',
      ],
    },
  };

  // ---------- download + getReport ----------
  const downloadReport = (): void => {
    setIsDownloadMode(true);

    setTimeout(async () => {
      const element =
        (componentRef.current as HTMLElement | null) ??
        (document.getElementById('downloadedContainer') as HTMLElement | null);
      if (!element) {
        setIsDownloadMode(false);
        return;
      }

      element.classList.add('pdf-mode');

      // mark critical blocks to avoid splitting
      element
        .querySelectorAll(
          `.${styles.smileScanReportOverview}, .${styles.smileScanReportDownloadHeader}, .${styles.smileScanReportDownloadFooter}, .${styles.smileScanReportDetails}, .${styles.smileScanReportOverviewText}`,
        )
        .forEach((n) => {
          (n as HTMLElement).classList.add('pdf-avoid-break');
          (n as HTMLElement).style.breakInside = 'avoid';
          (n as HTMLElement).style.pageBreakInside = 'avoid';
        });

      // Build dynamic image grid (2 columns per row, row = section) WITHOUT removing the first card
      const gridContainer = element.querySelector(`.${styles.smileScanReportDownloadGrid}`) as HTMLElement | null;
      if (gridContainer) {
        const uniqueImages = Array.from(new Set(images.map((img) => img.url)));

        // 1) Keep the first "score + colors" card
        const firstCard = gridContainer.querySelector(
          `.${styles.smileScanReportDownloadGridElementFirst}`,
        ) as HTMLElement | null;

        // Remove everything EXCEPT the first card
        Array.from(gridContainer.children).forEach((child) => {
          if (child !== firstCard) child.parentElement?.removeChild(child);
        });

        // 2) Create/clear a dedicated images grid AFTER the first card
        let imagesGrid = gridContainer.querySelector('.pdf-image-grid') as HTMLElement | null;
        if (!imagesGrid) {
          imagesGrid = document.createElement('div');
          imagesGrid.className = 'pdf-image-grid'; // defined in SCSS
          firstCard?.insertAdjacentElement('afterend', imagesGrid);
        } else {
          imagesGrid.innerHTML = '';
        }

        // 3) Build rows with 2 tiles each
        const makeTile = (url?: string) => {
          const tile = document.createElement('div');
          tile.className = 'pdf-image-tile pdf-avoid-break';
          (tile.style as any).breakInside = 'avoid';
          (tile.style as any).pageBreakInside = 'avoid';

          if (url) {
            const img = document.createElement('img');
            img.crossOrigin = 'anonymous';
            img.src = url;
            img.alt = 'SmileScan';
            (img.style as any).breakInside = 'avoid';
            (img.style as any).pageBreakInside = 'avoid';
            tile.appendChild(img);
          }
          return tile;
        };

        for (let i = 0; i < uniqueImages.length; i += 2) {
          // Row-level soft break markers so a whole row moves to next page if needed
          if (i > 0) {
            const br = document.createElement('div');
            br.className = 'pdf-break-before-row __auto';
            const spacer = document.createElement('div');
            spacer.className = 'pdf-page-spacer __auto';
            spacer.style.height = '12px';
            imagesGrid.appendChild(br);
            imagesGrid.appendChild(spacer);
          }

          const row = document.createElement('div');
          row.className = 'pdf-image-row pdf-avoid-break';
          (row.style as any).breakInside = 'avoid';
          (row.style as any).pageBreakInside = 'avoid';

          row.appendChild(makeTile(uniqueImages[i]));
          row.appendChild(makeTile(uniqueImages[i + 1])); // undefined => empty filler tile

          imagesGrid.appendChild(row);
        }

        // Allow breaks between rows, not inside them
        imagesGrid.style.breakInside = 'auto';
      }

      await waitForImages(element);

      applySmartPageBreaks(element, pdfMargin[0], pdfMargin[2]);

      const restoreHeaders = hideHeadersTemporarily(element);

      (html2pdf() as any)
        .set(commonPdfOptions)
        .from(element)
        .toPdf()
        .get('pdf')
        .then((pdf: any) => {
          drawPerPageHeader(pdf, pdfMargin);
        })
        .output('blob')
        .then((pdfBlob: Blob) => {
          const pdfUrl = URL.createObjectURL(pdfBlob);
          if (isMobile) {
            const newTab = window.open('about:blank', '_blank');
            if (newTab) newTab.location.href = pdfUrl;
            else alert('Please allow pop-ups to view the PDF.');
          }
          const a = document.createElement('a');
          a.href = pdfUrl;
          a.download = 'SmileScanReport.pdf';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(() => URL.revokeObjectURL(pdfUrl), 10000);
        })
        .catch((e: any) => console.error('❌ PDF download failed:', e))
        .finally(() => {
          element.classList.remove('pdf-mode');
          restoreHeaders();
          setIsDownloadMode(false);
        });
    }, 400);
  };

  const getReport = async (): Promise<UploadedFile | null> =>
    new Promise((resolve, reject) => {
      setIsDownloadMode(true);

      setTimeout(async () => {
        const element =
          (componentRef.current as HTMLElement | null) ??
          (document.getElementById('downloadedContainer') as HTMLElement | null);
        if (!element) {
          console.error('❌ Invalid componentRef for PDF');
          setIsDownloadMode(false);
          return reject(new Error('Invalid PDF element'));
        }

        const cloned = element.cloneNode(true) as HTMLElement;

        // ensure same no-split hints on clone
        cloned
          .querySelectorAll(
            `.${styles.smileScanReportOverview}, .${styles.smileScanReportDownloadHeader}, .${styles.smileScanReportDownloadFooter}, .${styles.smileScanReportDetails}, .${styles.smileScanReportOverviewText}`,
          )
          .forEach((n) => {
            (n as HTMLElement).classList.add('pdf-avoid-break');
            (n as HTMLElement).style.breakInside = 'avoid';
            (n as HTMLElement).style.pageBreakInside = 'avoid';
          });

        await waitForImages(cloned);
        applySmartPageBreaks(cloned, pdfMargin[0], pdfMargin[2]);

        const restoreHeaders = hideHeadersTemporarily(cloned);

        (html2pdf() as any)
          .set({
            ...commonPdfOptions,
            margin: pdfMargin,
          })
          .from(cloned)
          .toPdf()
          .get('pdf')
          .then((pdf: any) => {
            drawPerPageHeader(pdf, pdfMargin);
          })
          .output('datauristring')
          .then((dataUrl: string) => resolve({ name: 'SmileScanReport.pdf', dataURL: dataUrl }))
          .catch((error: any) => {
            console.error('❌ PDF generation failed in getReport:', error);
            reject(error);
          })
          .finally(() => {
            restoreHeaders();
            setIsDownloadMode(false);
          });
      }, 250);
    });

  const speakToDentist = async (): Promise<void> => {
    if (isSpeakingToDentist.current) return;
    isSpeakingToDentist.current = true;

    // Dispatch intake setup immediately so Redux is ready regardless of PDF outcome.
    dispatch(setForm([{ form_question_id: 17, value: { images: [] } }]));
    dispatch(setIsFromSmileScanReport(true));

    try {
      const selectedReport = smileScanReportsWithDiseaseAssessment[selectedSmileScanReport];
      const smileScanCaseImages = getSmileScanCaseImages(selectedReport, images);
      dispatch(setForm([{ form_question_id: 17, value: { images: smileScanCaseImages } }]));

      const pdfFile = await getReport();
      const uploadedFiles: UploadedFile[] = [...smileScanCaseImages, ...(pdfFile ? [pdfFile] : [])];
      dispatch(setForm([{ form_question_id: 17, value: { images: uploadedFiles } }]));
    } catch (err) {
      console.error('❌ speakToDentist: PDF/image prep failed, proceeding without:', err);
    } finally {
      isSpeakingToDentist.current = false;
    }

    roleNavigate('/select-patient', { state: { currentUserId: thisCase?.patient_id.toString() } });
  };

  const formatTime = (dateString: string, patientState: string): string => {
    const currentTimezone = getTimezoneAbbreviation(patientState);
    const timezoneWithUnderscore = convertZoneAbbr(currentTimezone as string);
    const date = moment.utc(dateString).tz(timezoneWithUnderscore);
    if (date && date.isValid()) {
      const daySuffix = (day: number): string => {
        if (day === 1 || day === 21 || day === 31) return 'st';
        if (day === 2 || day === 22) return 'nd';
        if (day === 3 || day === 23) return 'rd';
        return 'th';
      };
      const day = date.date();
      const year = date.format('YYYY');
      const prettyDate = `${date.format('MMMM D')}${daySuffix(day)}\u00A0${year}`;
      const compactDate = date.format('MMMM D,  YYYY');
      return prettyDate.length > 15 ? compactDate : prettyDate;
    }
    return '';
  };

  const dentalDiseaseAssessmentRowComponent = (disease: DiseaseAssessment): JSX.Element => {
    const rowStyle: React.CSSProperties = { breakInside: 'avoid', pageBreakInside: 'avoid' };
    return (
      <div
        className={`fs-exclude ${styles.dentalDiseaseAssessmentRow} pdf-avoid-break`}
        style={{
          ...rowStyle,
          borderColor:
            typeof disease.value === 'number'
              ? `${getGradeFromValue(disease).color}10`
              : disease.value
              ? '#FF000010'
              : '#13A70010',
        }}
        key={disease.id}
      >
        <div
          className={styles.dentalDiseaseAssessmentRowHeader}
          style={{
            backgroundColor:
              typeof disease.value === 'number'
                ? `${getGradeFromValue(disease).color}10`
                : disease.value
                ? '#FF000010'
                : '#13A70010',
          }}
        >
          <div className={`fs-unmask ${styles.dentalDiseaseAssessmentRowTitle}`} style={{ whiteSpace: 'nowrap' }}>
            {disease.title}
          </div>
          <div
            style={{
              color:
                typeof disease.value === 'number'
                  ? getGradeFromValue(disease).color
                  : disease.value
                  ? '#FF0000'
                  : '#13A700',
            }}
            className="fs-exclude"
          >
            {typeof disease.value === 'number' ? getGradeFromValue(disease).grade : disease.value ? 'Yes' : 'No'}
          </div>
        </div>
        <div className={styles.dentalDiseaseAssessmentRowContent}>
          <RiskTextDisplay category={disease.id as Category} riskLevel={getGradeFromValue(disease).id} />
        </div>
      </div>
    );
  };

  const SmileScanReportColors = (): JSX.Element => {
    const labelStyle: React.CSSProperties = { fontWeight: isDownloadMode ? 300 : undefined, whiteSpace: 'nowrap' };
    const box = (bg: string, label: string) => (
      <div className={styles.smileScanReportColor}>
        <div className={`fs-unmask ${styles.smileScanReportColorBox}`} style={{ backgroundColor: bg }} />
        <p className="fs-unmask" style={labelStyle}>
          {label}
        </p>
      </div>
    );
    return (
      <div className={`${styles.smileScanReportColors} pdf-avoid-break`} style={{ breakInside: 'avoid' }}>
        {box('#E60306', 'Area of concern on tooth')}
        {box('#1A00E0', 'Tartar buildup')}
        {box('#599A94', 'Inflammation of gums')}
        {box('#E49107', 'Gum recession')}
      </div>
    );
  };

  const SmileScanReport = (smileScanReport: SmileScanReportWithDiseaseAssessment): JSX.Element => {
    const { created_at, overall_score, diseaseAssessment } = smileScanReport;

    const noSplit: React.CSSProperties = { breakInside: 'avoid', pageBreakInside: 'avoid' };

    return (
      <>
        <div className={styles.smileScanReportContainer}>
          <div className={styles.smileScanReportWrapper}>
            <div className={`${styles.smileScanReportOverview} pdf-avoid-break`} style={noSplit}>
              <h1
                className={`fs-unmask ${styles.smileScanReportTitle}`}
                style={{ ...noSplit, marginTop: 0, paddingTop: 0 }}
              >
                Your SmileScan Report
              </h1>

              <div className={styles.smileScanReportOverviewWrapper} style={noSplit}>
                <div
                  className={styles.smileScanReportOverviewImages}
                  id="smileScanReportOverviewImages"
                  style={noSplit}
                >
                  <SlideshowProps images={images} />
                </div>
                <div className={styles.smileScanReportOverviewDetails} style={noSplit}>
                  <div className={styles.smileScanReportScores} style={noSplit}>
                    <div className={styles.smileScanReportScore}>
                      {smileScanReportsWithDiseaseAssessment.length > 1 && selectedSmileScanReport > 0 && (
                        <div className={styles.navigationButtons}>
                          <div
                            className={styles.navigationButton}
                            onClick={() => {
                              roleNavigate(
                                `/smile-scan-report/${
                                  smileScanReportsWithDiseaseAssessment[selectedSmileScanReport - 1].case_id
                                }`,
                              );
                            }}
                          >
                            <MdOutlineKeyboardArrowLeft />
                          </div>
                        </div>
                      )}
                      <div className={styles.smileScanReportScoreDetailsText}>
                        <p className="fs-unmask">SmileScan Score:</p>
                        <p className="fs-unmask">
                          <span className={styles.smileScanReportScoreDate}>
                            {formatTime(
                              created_at as string,
                              userInfo.role.name === UserRoleName.Patient ? currentState[userInfo.id] : 'NY',
                            )}
                          </span>
                        </p>
                      </div>
                      {smileScanReportsWithDiseaseAssessment.length > 1 &&
                        selectedSmileScanReport < smileScanReportsWithDiseaseAssessment.length - 1 && (
                          <div className={styles.navigationButtons}>
                            <div
                              className={styles.navigationButton}
                              onClick={() => {
                                roleNavigate(
                                  `/smile-scan-report/${
                                    smileScanReportsWithDiseaseAssessment[selectedSmileScanReport + 1].case_id
                                  }`,
                                );
                              }}
                            >
                              <MdOutlineKeyboardArrowRight />
                            </div>
                          </div>
                        )}
                    </div>

                    <div className={styles.smileScanReportScoreChanges} style={{ justifyContent: 'start' }}>
                      <p
                        className={styles.smileScanReportScoreValue}
                        style={{ color: getGradeFromOverallScore(overall_score as number).color }}
                      >
                        {overall_score}
                      </p>
                      {smileScanReportsWithDiseaseAssessment.length > 1 && selectedSmileScanReport !== 0 && (
                        <>
                          <div className={styles.verticalLine} />
                          <p className={styles.smileScanReportScoreChange}>
                            {calculateScoreChange(
                              smileScanReport?.overall_score as number,
                              smileScanReportsWithDiseaseAssessment[selectedSmileScanReport - 1]
                                ?.overall_score as number,
                            ).changeDirection === 'up' ? (
                              <img src={arrow} alt="Arrow" />
                            ) : (
                              <img src={arrow} alt="Arrow" style={{ transform: 'rotate(180deg)' }} />
                            )}
                            <span>
                              <b>
                                {
                                  calculateScoreChange(
                                    smileScanReport?.overall_score as number,
                                    smileScanReportsWithDiseaseAssessment[selectedSmileScanReport - 1]
                                      ?.overall_score as number,
                                  ).change
                                }
                              </b>{' '}
                              Change
                            </span>
                          </p>
                        </>
                      )}
                    </div>
                  </div>

                  <hr style={{ width: '100%', color: '#D0D0D0' }} />

                  <SmileScanReportColors />

                  {userInfo.role.name === UserRoleName.Patient && (
                    <div className={styles.smileScanReportButtonsContainer} style={{ marginTop: '12px' }}>
                      <div className={styles.smileScanReportButtons} style={{ width: '100%' }}>
                        <Button
                          className={`${styles.smileScanReportButton} fs-unmask ${styles.smileScanReportButtonSecondary}`}
                          style={{ width: '100%' }}
                          type="button"
                          onClick={() => {
                            speakToDentist();
                          }}
                        >
                          Review with a dentist
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className={`${styles.smileScanReportOverviewText} pdf-avoid-break`} style={noSplit}>
                <p className="fs-unmask  pdf-keep" style={{ marginTop: 0 }}>
                  Your oral health score is based on four SmileScan categories: area of concern on tooth, tartar
                  buildup, inflammation of gums, and gum recession. Each is weighted to create a score from 0-100, where
                  higher is healthier. Results may vary due to lighting, reflection, or natural differences.
                </p>
              </div>

              <div className={`${styles.smileScanReportNextStepsSection} pdf-avoid-break`} style={noSplit}>
                <h2 className={styles.nextStepsTitle} style={noSplit}>
                  Next steps
                </h2>

                <div className={styles.stepItem}>
                  <div className={styles.stepIcon}>1</div>
                  <div>
                    <div className={styles.stepHeading}>Choose How You’d Like to Review Your Results</div>
                    <div className={styles.stepText}>
                      Talk to a dentist on a live video call or have them send you a message.
                    </div>
                  </div>
                </div>

                <div className={styles.stepItem}>
                  <div className={styles.stepIcon}>2</div>
                  <div>
                    <div className={styles.stepHeading}>Go Over Your Results with a Dentist</div>
                    <div className={styles.stepText}>
                      Find out what’s healthy, what needs attention, and what to keep an eye on.
                    </div>
                  </div>
                </div>

                <div className={styles.stepItem}>
                  <div className={styles.stepIcon}>3</div>
                  <div>
                    <div className={styles.stepHeading}>Get a Personalized Treatment Plan</div>
                    <div className={styles.stepText}>
                      Receive a treatment plan tailored to you, with recommended next steps.
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.smileScanReportButtonsContainer} style={{ display: isMobile ? 'none' : 'block' }}>
                <div className={styles.smileScanReportButtons}>
                  {userInfo.role.name === UserRoleName.Patient && (
                    <>
                      <Button
                        className={`${styles.smileScanReportButton} fs-unmask ${styles.smileScanReportButtonSecondary}`}
                        type="button"
                        onClick={() => {
                          speakToDentist();
                        }}
                      >
                        Speak to a Dentist
                      </Button>
                      <button
                        className={`fs-unmask ${styles.smileScanReportCustomButton}`}
                        type="button"
                        onClick={downloadReport}
                      >
                        <img className="fs-unmask" src={download} alt="Download" style={{ width: 24, height: 24 }} />
                        Download your report
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div
            className={`${styles.smileScanReportDetails}`}
            style={{ breakInside: 'avoid', pageBreakInside: 'avoid' }}
          >
            {smileScanReport.diseaseAssessment.map((d) => dentalDiseaseAssessmentRowComponent(d))}
            <div className="pdf-avoid-break" style={{ paddingTop: '16px', width: '100%' }}>
              <div className={styles.smileScanReportButtonsContainer}>
                <div className={styles.smileScanReportButtons}>
                  {userInfo.role.name === UserRoleName.Patient && (
                    <>
                      <Button
                        className={`${styles.smileScanReportButton} fs-unmask ${styles.smileScanReportButtonSecondary}`}
                        type="button"
                        onClick={() => {
                          speakToDentist();
                        }}
                      >
                        Speak to a Dentist
                      </Button>
                      <button
                        className={`fs-unmask ${styles.smileScanReportCustomButton}`}
                        type="button"
                        onClick={() => {
                          roleNavigate('/smile-scan');
                        }}
                      >
                        Start a New Smilescan
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Force disclaimer to start on a new page and keep it together */}
          <div
            className={`${styles.smileScanReportDisclaimer} pdf-avoid-break pdf-break-before`}
            style={{ breakInside: 'avoid', pageBreakInside: 'avoid' }}
          >
            <p className="fs-unmask" style={{ marginTop: 0 }}>
              DISCLAIMER: The results of this report are part of a tool for pre-diagnostic information. They are not
              medical or diagnostic tools, and we do not claim that they diagnose any specific condition. They do not
              provide any medical advice and are not evaluated by a Provider. Factors such as lighting, reflection, or
              natural differences in teeth and gums may cause the AI to highlight areas that aren’t actually a problem.
              Not every mark or color change means there’s a dental issue. See the complete disclaimer by clicking{' '}
              <a target="_blank" rel="noreferrer" href="/smile-scan-disclaimer" className={styles.disclaimerLink}>
                here
              </a>
              .
            </p>
          </div>
        </div>

        {isDownloadMode && (
          <div
            className={styles.smileScanReportContainerDownload}
            ref={componentRef}
            id="downloadedContainer"
            style={{ display: isDownloadMode ? 'block' : 'none' }}
          >
            {/* in-DOM header hidden during PDF build; we draw a custom header instead */}
            <div className={styles.smileScanReportDownloadHeader} style={{ paddingBottom: '15px' }}>
              <div className={styles.smileScanReportDownloadHeaderLeft}>
                <span style={{ fontWeight: 'bold' }}>
                  {thisCase?.patient.basic_info.first_name} {thisCase?.patient.basic_info.last_name}
                </span>
                <span className={styles.smileScanReportScoreDate}>
                  {' '}
                  {formatTime(
                    created_at as string,
                    userInfo.role.name === UserRoleName.Patient ? currentState[userInfo.id] : 'NY',
                  )}
                </span>
              </div>
              <div className={styles.smileScanReportDownloadHeaderRight} style={{ height: 30 }}>
                <BrandLogo
                  crossOrigin="anonymous"
                  style={{ height: 30 }}
                  className={styles.logo}
                  customLogoUrl={isGumCase(thisCase) ? GumLogo : clientBranding?.logo_url}
                  fallbackLogo={!isMobile ? Logo : LogoMobile}
                  preserveOriginalColor
                />
              </div>
            </div>

            <div className={`${styles.smileScanReportOverviewText} pdf-avoid-break`} style={{ breakInside: 'avoid' }}>
              <p className="fs-unmask pdf-keep" style={{ marginTop: 0 }}>
                Your oral health score is based on four SmileScan categories: area of concern on tooth, tartar buildup,
                inflammation of gums, and gum recession. Each is weighted to create a score from 0-100, where higher is
                healthier. Results may vary due to lighting, reflection, or natural differences.
              </p>
            </div>

            <div className={styles.smileScanReportDownloadGrid}>
              <div
                className={`${styles.smileScanReportDownloadGridElement} ${styles.smileScanReportDownloadGridElementFirst} pdf-avoid-break`}
                style={{ breakInside: 'avoid', pageBreakInside: 'avoid' }}
              >
                <div className={styles.smileScanReportOverviewWrapper}>
                  <div className={styles.smileScanReportOverviewDetails} style={{ alignItems: 'center' }}>
                    <div className={styles.smileScanReportScores}>
                      <div className={styles.smileScanReportScore}>
                        <div className={styles.smileScanReportScoreDetailsText} style={{ alignItems: 'center' }}>
                          <p style={{ lineHeight: 1.2, textAlign: 'center' }}>
                            <b style={{ fontSize: 24 }}>SmileScan Score:</b>
                          </p>
                        </div>
                      </div>
                      <div className={styles.smileScanReportScoreChanges} style={{ width: 'fit-content' }}>
                        <div
                          className={styles.smileScanReportScoreValue}
                          style={{ color: getGradeFromOverallScore(overall_score as number).color }}
                        >
                          {overall_score}
                        </div>
                        {smileScanReportsWithDiseaseAssessment.length > 1 && selectedSmileScanReport > 0 && (
                          <>
                            <div className={styles.verticalLine} />
                            <div className={styles.smileScanReportScoreChange}>
                              {calculateScoreChange(
                                smileScanReport?.overall_score as number,
                                smileScanReportsWithDiseaseAssessment[selectedSmileScanReport - 1]
                                  ?.overall_score as number,
                              ).changeDirection === 'up' ? (
                                <img src={arrow} alt="Arrow" style={{ width: 11, height: 19 }} />
                              ) : (
                                <img
                                  src={arrow}
                                  alt="Arrow"
                                  style={{ transform: 'rotate(180deg)', width: 11, height: 19 }}
                                />
                              )}
                              <span style={{ paddingLeft: 5, fontWeight: 300, fontSize: 24 }}>
                                <b style={{ fontWeight: 700 }}>
                                  {
                                    calculateScoreChange(
                                      smileScanReport?.overall_score as number,
                                      smileScanReportsWithDiseaseAssessment[selectedSmileScanReport - 1]
                                        ?.overall_score as number,
                                    ).change
                                  }
                                </b>{' '}
                                Change
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    <div style={{ width: '70%' }}>
                      <SmileScanReportColors />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.smileScanReportDownloadHeader}>
              <div className={styles.smileScanReportDownloadHeaderLeft}>
                <span style={{ fontWeight: 'bold' }}>
                  {thisCase?.patient.basic_info.first_name} {thisCase?.patient.basic_info.last_name}
                </span>
                <span className={styles.smileScanReportScoreDate}>
                  {formatTime(
                    created_at as string,
                    userInfo.role.name === UserRoleName.Patient ? currentState[userInfo.id] : 'NY',
                  )}
                </span>
              </div>
              <div className={styles.smileScanReportDownloadHeaderRight}>
                <BrandLogo
                  crossOrigin="anonymous"
                  className={styles.logo}
                  customLogoUrl={isGumCase(thisCase) ? GumLogo : clientBranding?.logo_url}
                  fallbackLogo={!isMobile ? Logo : LogoMobile}
                  preserveOriginalColor
                />
              </div>
            </div>

            <div
              className={`${styles.smileScanReportDetails} pdf-avoid-break`}
              style={{ breakInside: 'avoid', pageBreakInside: 'avoid', paddingRight: 0, paddingLeft: 0 }}
            >
              {diseaseAssessment.map((d) => dentalDiseaseAssessmentRowComponent(d))}
            </div>

            <div className={`${styles.smileScanReportDownloadFooter} pdf-avoid-break`} style={{ breakInside: 'avoid' }}>
              <p className={`${styles.smileScanReportDownloadFooterP} pdf-keep`}>
                Visit <a href="https://app.dentistry.one/">Dentistry.One</a> to speak to a dentist about your SmileScan
                Report
              </p>
              <p className={`${styles.smileScanReportDownloadFooterDis} pdf-keep`}>
                DISCLAIMER: The results of this report are part of a tool for pre-diagnostic information. They are not
                medical or diagnostic tools, and we do not claim that they diagnose any specific condition. They do not
                provide any medical advice and are not evaluated by a Provider. Factors such as lighting, reflection, or
                natural differences in teeth and gums may cause the AI to highlight areas that aren’t actually a
                problem. Not every mark or color change means there’s a dental issue.
              </p>
            </div>
          </div>
        )}
      </>
    );
  };

  if (!videoCaseEnabled && videoCaseTypeEnabled) {
    return <VideoCaseNotAvailableModal onClose={() => setVideoCaseTypeEnabled(false)} />;
  }

  return (
    <Container
      isVisibleOnMobile
      containerStyle={{
        justifyContent: screenSize.width >= 564 ? 'center' : 'start',
        background: '#fff',
      }}
      childrenStyle={{ zIndex: '2', paddingTop: '0px' }}
    >
      {smileScanReportsWithDiseaseAssessment.length > 0 && !loading ? (
        SmileScanReport(smileScanReportsWithDiseaseAssessment[selectedSmileScanReport])
      ) : (
        <Loading fullScreen />
      )}
    </Container>
  );
};

export default SmileScanReportComponent;
